import React from "react"
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import IAddOn from "../../interfaces/IAddOn"
import { isOutOfStock, isLowStock, getInventoryWarningMessage, hasZeroOrBelowStock, hasLowStock, getInventoryWarningMessages } from "../../utils/inventoryHelpers"

interface InventoryWarningIconProps {
  product?: IAddOn
  products?: IAddOn[]
  size?: "sm" | "md" | "lg"
  className?: string
}

const InventoryWarningIcon: React.FC<InventoryWarningIconProps> = ({ 
  product, 
  products, 
  size = "md",
  className = "" 
}) => {
  const sizeClasses = {
    sm: "w-3.5 h-3.5",
    md: "w-5 h-5", 
    lg: "w-6 h-6"
  }

  // Single product warning
  if (product) {
    if (isOutOfStock(product)) {
      return (
        <ExclamationTriangleIcon 
          className={`${sizeClasses[size]} text-red-500 ${className}`} 
          title={getInventoryWarningMessage(product)} 
        />
      )
    }
    if (isLowStock(product)) {
      return (
        <ExclamationTriangleIcon 
          className={`${sizeClasses[size]} text-orange-400 ${className}`} 
          title={getInventoryWarningMessage(product)} 
        />
      )
    }
    return null
  }

  // Multiple products warning
  if (products) {
    const messages = getInventoryWarningMessages(products)
    
    if (hasZeroOrBelowStock(products)) {
      return (
        <ExclamationTriangleIcon 
          className={`${sizeClasses[size]} text-red-500 ${className}`} 
          title={messages.outOfStock} 
        />
      )
    }
    if (hasLowStock(products)) {
      return (
        <ExclamationTriangleIcon 
          className={`${sizeClasses[size]} text-orange-400 ${className}`} 
          title={messages.lowStock} 
        />
      )
    }
    return null
  }

  return null
}

export default InventoryWarningIcon 
